import React from 'react';
import useStyle from './challengeLotsBlock.style';

export interface ChallengeLotsBlockProps {
  headerText: string;
  headerDescriptionText?: string;
  descriptionText: string;
  imageSource?: 'iphone' | 'airpodspro' | 'airpods' | 'cartecadeau';
}

export const ChallengeLotsBlock = ({
  headerText = 'pas de titre',
  headerDescriptionText,
  descriptionText = 'pas de description',
  imageSource = 'iphone'
}: ChallengeLotsBlockProps) => {
  const classes = useStyle({ imageSource });

  return (
    <div className={`${classes.root} ${classes[imageSource]}`}>
      <div>
        <h5 className={classes.title}>{headerText}</h5>
        {headerDescriptionText && <p>{headerDescriptionText}</p>}
      </div>
      <p>{descriptionText}</p>
    </div>
  );
};
